<template>
  <m-dialog ref="previewzipCdg" :btnsave="false" :title="`PREVIEW KTA CADANGAN ` + items.length">
    <div v-for="preview in items" :key="preview.id" :id="`list-item-` + preview.id">
      <v-row no-gutters>
        <v-col cols="12" class="font-weight-bold"
          >NIK: {{ preview.nik }} <v-spacer></v-spacer>
          <v-btn :small="$vuetify.breakpoint.smAndDown" depressed color="amber" @click="regenerate(preview)"> <v-icon>mdi-refresh</v-icon>Regenerate </v-btn>
        </v-col>
        <v-col cols="10"><img height="250" class="pa-2" :src="preview.url_ktp_kta ? preview.url_ktp_kta + '?rand=' + Math.random() : 'img/no-image.jpeg'" alt="avatar"/></v-col>
      </v-row>
      <v-divider class="py-2"></v-divider>
    </div>
    <v-row wrap class="pb-0" v-if="page && page.last_page > 1">
      <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="5" sm="2" md="2" lg="2" class="text-left" align="center" justify="center">
        <p class="caption font-weight-bold ml-4">{{ page.total }} &nbsp;Data</p>
      </v-col>

      <v-col cols="12" sm="8" md="8" lg="8" class="text-center">
        <v-pagination v-if="page.total" :key="page_key" v-model="current_page" :length="page.last_page" :total-visible="6" @input="change"></v-pagination>
      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" v-if="page.from && $vuetify.breakpoint.lgAndUp" class="text-right">
        <p class="caption font-weight-bold mr-3">{{ page.from }} - {{ page.to }} dari {{ page.total }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
        ><v-spacer></v-spacer
        ><v-btn :small="$vuetify.breakpoint.smAndDown" :disabled="items.length === 0" depressed color="success" @click="download()">
          <v-icon>mdi-download</v-icon>Unduh
        </v-btn></v-col
      >
    </v-row>
  </m-dialog>
</template>

<script>
// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor";
// import { API } from "@/const";
// const M_API = API + "/api";
export default {
  components: {
    VueEditor
  },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      items: [],
      current_page: 1,
      cp: 1,
      dialog: true,
      page: null,
      paging: 6,
      page_key: 0,
      range: null,
      kotaid: null,
      params: {}
    };
  },
  methods: {
    // eslint-disable-next-line
    open(params) {
      // this.items = obj;
      this.params = params;
      this.current_page = 1;
      this.loadData();
      let x = this.$refs.previewzipCdg.open();
      this.$validator.reset();
      this.isReset = true;
      this.$nextTick(() => {
        this.isReset = false;
      });
      return x;
    },
    scrollTo(id) {
      document.getElementById("list-item-" + id).scrollIntoView();
    },
    change() {
      this.loadData();
    },
    loadData() {
      this.params.page = this.current_page;
      return this.$store
        .dispatch("warga/previewZIPCADANGAN", {
          params: this.params
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    download() {
      var items = this.items;
      this.params.preview = 0;
      return this.$store
        .dispatch("warga/downloadZIPCADANGAN", {
          params: this.params
        })
        .then(() => {
          this.params.preview = 1;
          this.items = items;
        })
        .catch(e => e);
    },
    regenerate(val) {
      var obj = {
        warga_id: val.id
      };
      return this.$store
        .dispatch("warga/regenerateKTPKTA", obj)
        .then(res => {
          // this.cetakZIP(val);
          val.url_ktp_kta = res.data.url_ktp_kta + "?rand=" + Math.random();
          this.$refs.previewzipCdg.close();
        })
        .then(() => {
          this.$refs.previewzipCdg.open();
          document.getElementById("list-item-" + val.id).scrollIntoView();
        })
        .catch(e => e);
    },

    cetakZIPCADANGAN(val) {
      this.params.preview = 1;
      return this.$store
        .dispatch("warga/previewZIPCADANGAN", {
          params: this.params
        })
        .then(res => {
          this.params.preview = 0;
        })
        .then(() => {
          document.getElementById("list-item-" + val.id).scrollIntoView();
        });
    }
  },
  watch: {
    page(n) {
      console.log(n);
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
      }
    }
  }
};
</script>
